export const ICON_ALIASES: Record<string, string> = {
  alert: "warning",
  warning: "warning",
  "arrow-up": "arrow_upward",
  "arrow-left": "arrow_back",
  "arrow-right": "arrow_forward",
  "arrow-left-straight": "arrow_back",
  "arrow-right-straight": "arrow_forward",
  "arrow-left-square": "arrow_circle_left",
  "arrow-right-square": "arrow_circle_right",
  "arrow-rotate": "refresh",
  globe: "globe",
  bell: "notifications",
  billing: "credit_card",
  bug: "bug_report",
  check: "check",
  "check-bold": "check",
  "check-shaped": "check_circle",
  "rounded-check": "check_circle",
  success: "check_circle",
  chevron: "keyboard_arrow_down",
  "chevron-down": "keyboard_arrow_down",
  clear: "cancel",
  close: "close",
  copy: "content_copy",
  "bar-chart": "bar_chart",
  "dashboard-plots": "monitoring",
  data: "database",
  "data-analysis": "analytics",
  delete: "delete",
  documentation: "assignment",
  download: "download",
  home: "home",
  import: "download",
  edit: "edit",
  "edit-pencil": "edit",
  email: "mail",
  fire: "local_fire_department",
  info: "info",
  "info-circle": "info",
  invite: "person_add",
  laptop: "computer",
  location: "location_on",
  lock: "lock",
  logout: "logout",
  "open-in-new": "open_in_new",
  menu: "menu",
  more: "more_horiz",
  molecule: "science",
  moon: "dark_mode",
  sun: "light_mode",
  plus: "add",
  minus: "remove",
  "run-graph": "hub",
  progress: "progress_activity",
  "run-setup": "rocket_launch",
  search: "search",
  "search-with-plus": "zoom_in",
  "select-box": "crop_square",
  settings: "settings",
  parameters: "tune",
  phone: "call",
  target: "target",
  "target-anti": "swap_horiz",
  user: "person",
  "user-deactivate": "person_off",
  "user-guide": "menu_book",
  "user-remove": "person_remove",
  "user-settings": "manage_accounts",
};
